export const BOAXEL = "boaxel";
export const MOUNTING_RAIL = "mountingRail";
export const UPRIGHT = "upright";
export const MOUNTING_RAIL_TYPE_CODE = "29990";
export const LENGTH_TYPE_CODE = "00001";
export const SECTION_MAX_WIDTH = 800;
